class EnumHelper {
  static getEnumKeyByValue<T extends { [key: string]: string }>(
    enumObj: T,
    value: string,
  ): keyof T | undefined {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const entry = Object.entries(enumObj).find(([_, val]) => val === value);
    return entry ? (entry[0] as keyof T) : undefined;
  }

  static stringToEnum = <T extends Record<string, string>>(
    enumObj: T,
    value: string,
  ): T[keyof T] | undefined => {
    return Object.values(enumObj).includes(value)
      ? (value as T[keyof T])
      : undefined;
  };
}

export default EnumHelper;
